/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Backtolearn2Inputs */

const zh_learn_backtolearn2 = /** @type {(inputs: Learn_Backtolearn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回学习`)
};

const en_learn_backtolearn2 = /** @type {(inputs: Learn_Backtolearn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Learn`)
};

const es_learn_backtolearn2 = /** @type {(inputs: Learn_Backtolearn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a Learn`)
};

/**
* | output |
* | --- |
* | "Back to Learn" |
*
* @param {Learn_Backtolearn2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_backtolearn2 = /** @type {((inputs?: Learn_Backtolearn2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Backtolearn2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_backtolearn2(inputs)
	if (locale === "en") return en_learn_backtolearn2(inputs)
	return es_learn_backtolearn2(inputs)
});
export { learn_backtolearn2 as "learn_backToLearn" }